import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IDropdown } from '../../../interfaces';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html'
})
export class DropdownComponent implements OnInit {
    @Input() title: string | null;
    @Input() options: IDropdown[];
    @Input() default: number | null;
    @Output() select: EventEmitter<IDropdown> = new EventEmitter();
    selectedOption: string;

    ngOnInit(): void {
        if (this.default) {
            const index = this.options.findIndex(o => o.id === this.default);
            this.selectedOption = this.options[index].text;
        } else if (this.title) {
            this.selectedOption = this.title;
        } else {
            this.selectedOption = 'Nu este selectat';
        }
    }

    selectOption(option: IDropdown): void {
        this.select.emit(option);
        this.selectedOption = option.text;
    }
}
